import { OrganizationSummary, PlatformMetrics, ReferenceDataResponse } from "../../interfaces/superAdmin/SuperAdmin";

// Define strict return types for the paginated response
interface PagedOrganizationResponse {
    data: OrganizationSummary[];
    totalRecords: number;
    pageNumber: number;
    pageSize: number;
}

export async function getAllOrganizations(
    authToken: string, 
    pageNumber: number = 1, 
    pageSize: number = 10, 
    searchTerm: string = ""
): Promise<PagedOrganizationResponse | null> {
    try {
        const queryParams = new URLSearchParams({
            PageNumber: pageNumber.toString(),
            PageSize: pageSize.toString(),
            SearchTerm: searchTerm
        });

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/dashboard/organizations?${queryParams}`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch organizations:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching organizations:", error);
        return null;
    }
}

export async function getPlatformMetrics(authToken: string): Promise<PlatformMetrics | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/dashboard/metrics`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch platform metrics:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching platform metrics:", error);
        return null;
    }
}

export async function getReferenceData(authToken: string): Promise<ReferenceDataResponse | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/dashboard/reference-data`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch reference data:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching reference data:", error);
        return null;
    }
}